// New in 2018-12 - take some clutter out of LocalApi
// by placing each navigation widget here.

import Orchestrator from '../../lib/Orchestrator';
import HamburgerButton from './HamburgerButton';
import CategoryMenuBar from './CategoryMenuBar';
import DropBannerBar from './DropBannerBar';

export default class PageNavigation extends Orchestrator {

  startup(page) {
    // 2025-07 moved to inline JS in header.
    // in MOBILE ONLY, the magnifying glass
    /// icon toggles visibility of a drop-down search widget.
    //this.search_button = new SearchButton().startup(page);

    // 2025-07 this did nothing
    // this.search_form = new SearchForm().startup(page);

    this.hamburgerButton = new HamburgerButton().startup(page);

    this.categoryMenuBar = new CategoryMenuBar().startup(page);

    this.dropBannerBar = new DropBannerBar().startup(page);

    return this;
  }
}
